export const MAPCONTROL_NAME = "Print";

export const DEFAULT_DRAWING_TOOLS = ["Point", "LineString", "Polygon", "Select", "Modify"];